import {
  APIProvider,
  Map,
  MapCameraChangedEvent,
  AdvancedMarker,
  Pin,
} from "@vis.gl/react-google-maps";
import { React, useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Loading from "../components/Loading";
import MapMarker from "../components/MapMarker";
import axios from "axios";

function MapComponent(props) {
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      {props.isLoading ? (
        <Loading containerDims="Loading" spinnerDims="loading-map"></Loading>
      ) : (
        <div className="Map-Container">
          <Map
            defaultZoom={3}
            defaultCenter={{ lat: -33.860664, lng: 151.208138 }}
            mapId="DEMO_MAP_ID"
          >
            <MapMarker onClick={props.onClick} markers={props.markers} />
          </Map>
        </div>
      )}
    </APIProvider>
  );
}
export default MapComponent;
